import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlacementsOtherinfoListComponent } from './placements-otherinfo-list/placements-otherinfo-list.component';
import { PlacementsOtherinfoCreateComponent } from './placements-otherinfo-create/placements-otherinfo-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: PlacementsOtherinfoListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: PlacementsOtherinfoCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'section-create/:id',
        component: PlacementsOtherinfoCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlacementsOtherinfoRoutingModule { }
